import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Copy, FileArrowDown } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'
import api from '../../../api/api'
import downloadTxtFile from '../../../helpers/txtDownload'

import AudioPlayer from './AudioPlayer'

const AudioMessageRecord = ({ transcriptionUrl, recordingUrl, transcriptionBegin }) => {
  const { t } = useTranslation(['chat'])
  const [openModal, setOpenModal] = useState(false)
  const { displaySnackbar } = useSnackbar()
  const [fullTranscription, setFullTranscription] = useState('')
  const fetchFullTranscription = async () => {
    if (!transcriptionUrl || fullTranscription) return

    try {
      const { data } = api.getFullTranscription(transcriptionUrl)
      setFullTranscription(data)
    } catch (err) {
      console.error(err)
    }
  }
  useEffect(() => {
    fetchFullTranscription()
  }, [])

  const copyText = () => {
    if (!fullTranscription) return
    navigator.clipboard.writeText(fullTranscription).then(
      () => {
        displaySnackbar(t('chat:audioMessageRecord.copySuccess'))
      },
      () => {
        displaySnackbar(t('chat:audioMessageRecord.copyFailure'), true)
      },
    )
  }

  return (
    <div className="media-player">
      <AudioPlayer recordingUrl={recordingUrl} />
      <div className="transcript">
        <div className="actions">
          <h5 className="actions-title">{t('chat:audioMessageRecord.transcript')}</h5>
          {transcriptionBegin && (
            <React.Fragment>
              <button onClick={copyText} className="media-player-btn" disabled={!fullTranscription}>
                <Copy size={16} />
              </button>
              <button
                onClick={() => downloadTxtFile(fullTranscription, 'transcription')}
                className="media-player-btn"
                disabled={!fullTranscription}
              >
                <FileArrowDown size={16} />
              </button>
            </React.Fragment>
          )}
        </div>
        <p>{transcriptionBegin || t('chat:audioMessageRecord.noTranscription')}</p>
        {transcriptionBegin && (
          <button
            onClick={() => setOpenModal(true)}
            className="media-player-btn"
            disabled={!fullTranscription}
          >
            <div className="view-more">{t('chat:audioMessageRecord.viewMore')}</div>
          </button>
        )}
      </div>
      {openModal && (
        <ModalContainer
          additionalClass="transcript-modal"
          headerTitle={t('chat:audioMessageRecord.callVoicemailTranscript')}
          onClose={() => setOpenModal(false)}
        >
          {fullTranscription}
        </ModalContainer>
      )}
    </div>
  )
}

export default AudioMessageRecord

AudioMessageRecord.propTypes = {
  transcriptionUrl: PropTypes.string,
  transcriptionBegin: PropTypes.string,
  recordingUrl: PropTypes.string,
}
